import React from 'react';

import { ReactComponent as PhotoIcon } from '@assets/svg/ic-photoframe.svg';

import type { IGalleryPhoto } from '@components/modals/EditSensorGalleryModal/constants/sensorGalleryType';
import Button from '@components/uikit/Button/Button';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import type { IInstallationPoint } from '@model/installationPoint';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  images?: IGalleryPhoto[];
  installationPoints?: IInstallationPoint[];
  equipmentName?: string;
}

const EmptySensorGalleryBlock = ({ images, installationPoints, equipmentName }: IProps) => {
  const { setActiveModal } = useModalActions();
  const { t } = useTranslation();

  return (
    <div className={style.sensorGallery}>
      <div className={style.noImageGallery}>
        <PhotoIcon className={style.photoIcon} />
        <div>
          <span className={style.noImageTitle}>{t('No photos yet')}</span>
          <span className={style.noImageDescription}>
            {t('Upload photos to visually document the equipment’s technical details')}
          </span>
        </div>
        <Button
          onClick={() =>
            setActiveModal({
              name: MODAL_NAMES.editSensorGalleryModal,
              options: {
                images: images,
                installationPoints: installationPoints,
                equipmentName: equipmentName,
              },
            })
          }
          type="secondary"
          text={t('Add Photos')}
        />
      </div>
    </div>
  );
};

export default EmptySensorGalleryBlock;
